import {
  CcfBox,
  CcfThumbsDownIcon,
  CcfThumbsUpIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import styles from './ccf-app-enlighten.module.scss';

/* eslint-disable-next-line */
export interface CcfAppEnlightenProps {}

/**
 * used to show App enlighten static screen in app space
 * @param props - CcfAppEnlightenProps
 * @example ` <CcfAppEnlighten />`
 */
export function CcfAppEnlighten(props: CcfAppEnlightenProps) {
  const enlightenData = [
    {
      heading: 'How to earn rewards with your Lowe’s Credit Card?',
      data: 'Customers earn 5 points for each dollar spent at Lowe’s.',
    },
    {
      heading: 'How long does it take for points to post to my account?',
      data: 'Please allow 5-7 business days for points to show up in your account.',
    },
    {
      heading: 'How can I redeem points?',
      data: 'Points can be redeemed for statement credit or cash back.',
    },
    {
      heading: 'Do points have expiration dates?',
      data: 'Lowe’s reward points do not have an expiration date',
    },
  ];
  return (
    <CcfBox style={{ height: '100%' }}>
      <CcfBox className={styles.articleSuggestionBox}>
        <CcfTypography className={styles.txtArticleSuggestion}>
          Article Suggestions
        </CcfTypography>
      </CcfBox>
      <CcfBox className={styles.accountManagementBox}>
        <CcfTypography className={styles.txtAccountManagement}>
          “Account Management”
        </CcfTypography>
      </CcfBox>
      <div style={{ height: 'calc(100% - 75px)', overflow:'auto' }}>
        {enlightenData.map((data, index) => (
          <>
            <CcfBox className={styles.enlightenDataBox}>
              <CcfTypography className={styles.enlightenDataHeader}>
                {data.heading}
              </CcfTypography>
              <CcfTypography className={styles.enlightenDataText}>
                {data.data}
              </CcfTypography>
            </CcfBox>
            <CcfBox className={styles.feedBackBlock}>
              <CcfTypography className={styles.helpfulText}>
                Was this helpful?
              </CcfTypography>
              <CcfThumbsUpIcon
                style={{ fontSize: '18px', marginRight: '15px' }}
              />
              <CcfThumbsDownIcon style={{ fontSize: '18px' }} />
              <CcfBox className={styles.addToUrlBox}>
                <CcfTypography className={styles.addtoURLText}>
                  Add URL to Chat
                </CcfTypography>
              </CcfBox>
            </CcfBox>
          </>
        ))}
      </div>
    </CcfBox>
  );
}

export default CcfAppEnlighten;
